import { useState } from 'react';
import classNames from 'classnames';
import {
  Link,
} from 'react-router';
import {
  VibeButton,
} from 'vibeguide';
import {
  FormHelperText,
} from '@mui/material';
import {
  AccountCircle,
  Lock,
} from '@mui/icons-material';
import './LoginForm.scss';

function LoginForm({
  username: propUsername = '',
  password: propPassword = '',
  loginError = false,
  loginErrorMessage = '',
  cookiesAccepted = false,
  onUsernameChange = () => {},
  onPasswordChange = () => {},
  onForgotPassword = () => {},
  checkCredentials = () => {},
}) {
  const [username, setUsername] = useState(propUsername);
  const [password, setPassword] = useState(propPassword);
  const [isAccountFocus, setIsAccountFocus] = useState(false);
  const [isPasswordFocus, setIsPasswordFocus] = useState(false);
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const onChangeUsername = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setUsername(value);
    onUsernameChange(e);
  };

  const onChangePassword = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setPassword(value);
    onPasswordChange(e);
  };

  const onKeyDown = (e) => {
    const capsLockOn = e.getModifierState('CapsLock');

    if (!isCapsLockOn && capsLockOn) {
      // Caps lock is on
      setIsCapsLockOn(true);
    } else if (isCapsLockOn && !capsLockOn) {
      // Caps lock is off
      setIsCapsLockOn(false);
    }

    if (e.key === 'Enter') {
      checkCredentials(e);
    }
  };

  return (
    <div
      className="LoginForm"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
      }}
    >
      <div
        className="form-title"
        style={{
          fontSize: 16,
          textAlign: 'center',
        }}
      >
        Your retail platform to standardize and unify digital in-store.
      </div>

      <form className="login-container">
        <div className={classNames('input-container', { active: isAccountFocus })}>
          <input
            className="login-input"
            type="email"
            placeholder="Username"
            value={username}
            // defaultValue={username}
            onChange={onChangeUsername}
            onKeyDown={onKeyDown}
            onFocus={() => setIsAccountFocus(true)}
            onBlur={() => setIsAccountFocus(false)}
            disabled={!cookiesAccepted}
            autoFocus
          />

          <AccountCircle className="login-icon account-icon" />

          {isCapsLockOn && (
            <FormHelperText className="login-capslock">
              CAPSLOCK is on
            </FormHelperText>
          )}
        </div>

        <div
          className={classNames('input-container', { active: isPasswordFocus })}
        >
          <input
            className="login-input"
            type="password"
            placeholder="********"
            // defaultValue={password}
            value={password}
            onChange={onChangePassword}
            onKeyDown={onKeyDown}
            onFocus={() => setIsPasswordFocus(true)}
            onBlur={() => setIsPasswordFocus(false)}
            disabled={!cookiesAccepted}
          />

          <Lock className="login-icon lock-icon" />

          {loginError && (
            <FormHelperText className="login-error">
              {loginErrorMessage}
            </FormHelperText>
          )}
        </div>

        {cookiesAccepted && (
          <Link
            className="forgot"
            to="/forgot"
            onClick={onForgotPassword}
          >
            Forgot password
          </Link>
        )}

        {cookiesAccepted && (
          <VibeButton
            style={{
              width: '100%',
              height: 48,
              fontSize: 16,
            }}
            text="Sign in"
            color="primary"
            disabled={password.length <= 0 || !username}
            onClick={checkCredentials}
          />
        )}
      </form>
    </div>
  );
}

export default LoginForm;
